import { useContext } from 'react';

import { Row } from 'react-table';

import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';
import { TEventListItem } from 'types';
import { logDescriptionTemplate } from 'utils';

export const getLogDescription = (
  row: Row<TEventListItem>
): JSX.Element | string => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { currency, postPaymentMaxDuration },
    },
  } = useContext(SettingsContext);

  const template = logDescriptionTemplate.get(row.original.type);
  return template
    ? template(row, t, currency, postPaymentMaxDuration)
    : `Unknown log type: ${row.original.type}`;
};
